'use client';

import { type RefObject, type PropsWithChildren } from 'react';
import { CarouselProvider } from '@packages/modules/src/Carousel/CarouselProvider';
import { CarouselWrapper } from '@packages/modules/src/Carousel/CarouselWrapper.client';
import { CarouselNav } from '@packages/modules/src/Carousel/CarouselNav.client';
import { CarouselVirtualizedList } from '@packages/modules/src/Carousel/CarouselVirtualizedList.client';
import {
  RecoCarouselLoadingList,
  type RecoCarouselLoadingListProps,
} from './RecoCarouselLoadingList.client';
import { RecoCarouselTitle } from './RecoCarouselTitle/RecoCarouselTitle';

type RecoCarouselProps = PropsWithChildren<{
  title: string;
  preferTitle?: boolean;
  loadingState?: boolean;
  backgroundColor?: string;
  ref?: RefObject<HTMLDivElement | null>;
}> &
  Pick<RecoCarouselLoadingListProps, 'type'>;

const visibleItemsCssProps =
  '[--items-visible:2.15] [--reco-gap:0.75rem] @xl:[--items-visible:3.5] @4xl:[--items-visible:4.5]';

export const RecoCarousel = ({
  children,
  title,
  preferTitle,
  loadingState = false,
  backgroundColor,
  ref,
  type = 'PRODUCT',
}: RecoCarouselProps) => (
  <div ref={ref}>
    <RecoCarouselTitle title={title} preferTitle={preferTitle} loadingState={loadingState} />
    <CarouselProvider>
      <CarouselWrapper style={{ backgroundColor }}>
        {loadingState ? (
          <RecoCarouselLoadingList type={type} className={visibleItemsCssProps} />
        ) : (
          <>
            <CarouselNav />
            <CarouselVirtualizedList
              className={`scroll-px-1 p-1 ${visibleItemsCssProps}`}
              initialRenderCount={3}
            >
              {children}
            </CarouselVirtualizedList>
          </>
        )}
      </CarouselWrapper>
    </CarouselProvider>
  </div>
);
